import type { FrontendWidget } from '../types';
import { LocationSearchResultsComponent } from './LocationSearchResultsComponent';
import type {
  LocationSearchResultsConfig,
  LocationSearchResultsResolved,
} from './types';

export const locationSearchResultsWidget: FrontendWidget<
  LocationSearchResultsConfig,
  LocationSearchResultsResolved
> = {
  componentType: 'widgets.location-search-results',
  displayName: 'Location Search Results',
  ComponentA: LocationSearchResultsComponent,
  // Inline widget (30.03.05): the hits come from the render context, not from
  // a backend resolver — `POST /render-page` never sees the query string.
  resolveSync: (config) => config,
};
